import { useEffect } from 'react'

interface SeoProps {
  title: string
  description: string
  url: string
  image?: string
  robots?: string
  googleBot?: string
  type?: string
}

const SITE_NAME = 'tsibel.com'
const DEFAULT_IMAGE = 'https://tsibel.com/1200x630.jpg'
const DEFAULT_TWITTER_CARD = 'summary_large_image'

const setMetaTag = (attribute: 'name' | 'property', key: string, content: string) => {
  const selector = `meta[${attribute}="${key}"]`
  let meta = document.head.querySelector(selector) as HTMLMetaElement | null

  if (!meta) {
    meta = document.createElement('meta')
    meta.setAttribute(attribute, key)
    document.head.appendChild(meta)
  }

  meta.setAttribute('content', content)
}

const setCanonical = (href: string) => {
  let canonical = document.head.querySelector('link[rel="canonical"]') as HTMLLinkElement | null

  if (!canonical) {
    canonical = document.createElement('link')
    canonical.setAttribute('rel', 'canonical')
    document.head.appendChild(canonical)
  }

  canonical.setAttribute('href', href)
}

const Seo = ({
  title,
  description,
  url,
  image = DEFAULT_IMAGE,
  robots = 'index, follow',
  googleBot = robots,
  type = 'website'
}: SeoProps) => {
  useEffect(() => {
    document.title = title

    setMetaTag('name', 'description', description)
    setMetaTag('name', 'robots', robots)
    setMetaTag('name', 'googlebot', googleBot)
    setMetaTag('name', 'twitter:card', DEFAULT_TWITTER_CARD)
    setMetaTag('name', 'twitter:title', title)
    setMetaTag('name', 'twitter:description', description)
    setMetaTag('name', 'twitter:image', image)

    setMetaTag('property', 'og:site_name', SITE_NAME)
    setMetaTag('property', 'og:type', type)
    setMetaTag('property', 'og:title', title)
    setMetaTag('property', 'og:description', description)
    setMetaTag('property', 'og:url', url)
    setMetaTag('property', 'og:image', image)

    setCanonical(url)
  }, [description, googleBot, image, robots, title, type, url])

  return null
}

export default Seo
